import React, { useState, useEffect } from 'react';
import ListItem from './ListItem.js';

export default function ListView({ setBatch, batchList, archivedBatchList, curUser, updateUTMList, setArchivedBatchList }) {
  const [archiveDisplayed, setArchiveDisplayed] = useState(false);
  const [displayList, setDisplayList] = useState(batchList);

  // Toggle between displaying the archived or non-archived list
  const toggleArchive = () => {
    setArchiveDisplayed((prevState) => !prevState);
  };

//this functions handle the FE visual change of placing the newly archive/unarchived item into its respective group while the ajax call is working behind the scenes
  const toggleArchiveStatus = (batch_id, archive) => {
    if (archive) {
      //set the item to archive from the current batchlist
      const itemToArchive = batchList.flat().find((item) => item.batch_id === batch_id);
  
      if (itemToArchive) {
        //move the item from fetchedUTMList (updateUTMList - someone didn't know useState nameing conventions) to archivedBatchList
        updateUTMList((prev) => prev.flat().filter((item) => item.batch_id !== batch_id));
        setArchivedBatchList((prev) => [...prev, { ...itemToArchive, archived: true }]);
      }
    } else {
      // set the item to unarchive from the current archive list
      const itemToUnarchive = archivedBatchList.flat().find((item) => item.batch_id === batch_id);
  
      if (itemToUnarchive) {

        // Move the item from archivedBatchList to fetchedUTMList (see comment above but fetchedUTMList is coupled to UpdateUTMList)
        setArchivedBatchList((prev) => prev.flat().filter((item) => item.batch_id !== batch_id));
        updateUTMList((prev) => [...prev, { ...itemToUnarchive, archived: false }]);
      }
    }
  };  

  // Update the display list when batchList or archivedBatchList changes
  useEffect(() => {
    if (archiveDisplayed) {
      setDisplayList(archivedBatchList);
    } else {
      setDisplayList(batchList);
    }
  }, [archiveDisplayed, batchList, archivedBatchList]);

  return (
    <div className="container u--margin-top-35">
      <CreateUTMButtons
        createBatch={setBatch}
        curUser={curUser}
        toggleArchive={toggleArchive}
        archiveDisplayed={archiveDisplayed}
      />
      <ListHeaders />
      {displayList.flat().map((listItem) => (
        <ListItem
          key={listItem.batch_id}
          item={listItem}
          editUTMs={setBatch}
          archiveStatus={archiveDisplayed}
          toggleArchiveStatus={() => toggleArchiveStatus(listItem.batch_id, !listItem.archived)}
        />
      ))}
    </div>
  );
}

function CreateUTMButtons({
  createBatch,
  curUser,
  toggleArchive,
  archiveDisplayed
}) {
  const newBatch = {
    batch_id: '',
    user: curUser,
    organization: 'User Org',
    groupName: '',
    utm_codes: []
  };

  return (
    <div className="grid grid--between">
      <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <p>
          <button className="btn btn--blue" onClick={() => createBatch(newBatch)}>
            <span className="btn__content">
              <span className="btn__text">Create New UTM</span>
            </span>
          </button>
        </p>
      </div>
      <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <p>
          <button className="btn btn--blue" onClick={toggleArchive}>
            <span className="btn__content">
              <span className="btn__text">
                {archiveDisplayed ? 'Hide Archived' : 'Show Archived'}
              </span>
            </span>
          </button>
        </p>
      </div>
    </div>
  );
}

function ListHeaders() {
  return (
    <div className="u--margin-auto">
      <div className="grid utm__list-headers">
        <div className="grid__col-lg-3">Date</div>
        <div className="grid__col-lg-2">User</div>
        <div className="grid__col-lg-1">Org</div>
        <div className="grid__col-lg-3">Group Name</div>
        <div className="grid__col-lg-1">#UTMs</div>
        <div className="grid__col-lg-2">Actions</div>
      </div>
    </div>
  );
}
